import { AuthInterceptorServiceFactory } from '@treasury/domain/shared/interceptors';

angular.module('backOffice').factory('authInterceptorService', AuthInterceptorServiceFactory);
